<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <p>© 2025 Rockstar. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </footer>  
</template>

<script>
export default {
  name: 'FooterMain',
  props: {
    msg: String
  },
  mounted() {
    this.loadScript('https://code.jquery.com/jquery-3.6.0.min.js');
    this.loadScript('https://cdnjs.cloudflare.com/ajax/libs/jquery-migrate/3.4.1/jquery-migrate.min.js');
    this.loadScript('https://cdn.jsdelivr.net/npm/@popperjs/core@2.11.7/dist/umd/popper.min.js');
    this.loadScript('https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js');
    this.loadScript('/assets/js/custom.js');

  },
  methods: {
    loadScript(src) {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }
  }
}
</script>

<style scoped>
/* Add footer-specific styles here if needed */
</style>
